/**
 * Normalize a trusted-domain hostname for storage/display (matches backend EmbedFormDomainValidator).
 */
export function normalizeTrustedDomainInput(input) {
    let value = String(input ?? "").trim().toLowerCase();
    if (value === "") {
        return "";
    }

    if (value.includes("://")) {
        try {
            const url = new URL(value);
            value = url.hostname.toLowerCase();
        } catch {
            // Keep trimmed lowercase input; backend validates on save.
        }
    }

    return value.replace(/^\/+|\/+$/g, "");
}

/** Build an https URL for opening a trusted domain in a new tab. */
export function trustedDomainHref(domain) {
    const normalized = normalizeTrustedDomainInput(domain);
    if (!normalized) {
        return "#";
    }
    if (normalized === "localhost") {
        return "http://localhost";
    }
    return `https://${normalized}`;
}
